import type * as React from 'react';

/**
 * Flat Forest band that opens every Channel Partner page — the brand's
 * inverse surface (cream serif title, amber eyebrow). Actions such as the Hub
 * bell sit on the right.
 */
export function ChannelPartnerHero({
  eyebrow,
  title,
  description,
  children,
}: {
  eyebrow: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
}) {
  return (
    <div className="bg-forest py-6 sm:py-8">
      <div className="mx-auto flex max-w-7xl flex-wrap items-end justify-between gap-4 px-4 sm:px-6">
        <div className="min-w-0 animate-slide-up-fade">
          <p className="mb-1 text-[10px] font-semibold uppercase tracking-widest text-amber">
            {eyebrow}
          </p>
          <h1 className="font-display text-2xl font-semibold leading-tight tracking-tight text-cream sm:text-3xl">
            {title}
          </h1>
          {description && (
            <p className="mt-1 max-w-2xl text-xs text-cream/75 sm:text-sm">{description}</p>
          )}
        </div>
        {children && <div className="flex shrink-0 items-center gap-2">{children}</div>}
      </div>
    </div>
  );
}
